import React from 'react';
import ReactModal from 'react-modal';
import { PhaseResult } from 'pages/user-test/store';
import { useTranslation } from 'react-i18next';
import { Column } from 'components/Column';
import { Icon } from 'components/Icon';
import { dateTimeFormat } from 'constants/date-format';
import moment from 'moment';
import { PhasesList } from './PhaseList';

interface PhasesModalProps {
    isOpen: boolean;
    handleCloseClick: () => void;
    phases: PhaseResult[];
    theme?: 'standard' | 'modified' | 'modified-darkened';
    additionalClasses?: string;
    showDetails?: boolean;
}

ReactModal.setAppElement('body');

export const PhaseVisual = (props: PhasesModalProps) => {
    const { isOpen, handleCloseClick, phases, theme, additionalClasses, showDetails } = props;
    const [t] = useTranslation(['user-test']);
    const modalTheme = theme || 'standard';

    return (
        <Column columnSize="100">
            <ReactModal
                isOpen={isOpen}
                onRequestClose={handleCloseClick}
                className={`phases-modal react-modal react-modal-${modalTheme} ${
                    additionalClasses ? additionalClasses : ''
                }`}
                overlayClassName={`react-modal-overlay react-modal-overlay-${modalTheme}`}
            >
                <div onClick={handleCloseClick} className={`details-modal-close ${modalTheme}`}>
                    <Icon iconName="close" />
                </div>
                <PhasesList phases={phases} showDetails={showDetails} />
            </ReactModal>
        </Column>
    );
};
